import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=3396eea6&scoped=true&"
import script from "./Cursos.vue?vue&type=script&lang=js&"
export * from "./Cursos.vue?vue&type=script&lang=js&"
import style0 from "./Cursos.vue?vue&type=style&index=0&id=3396eea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396eea6",
  null
  
)

export default component.exports